import * as Scrivito from "scrivito";
import metadataAttributes from "../_metadataAttributes";
import defaultPageAttributes from "../_defaultPageAttributes";

const Author = Scrivito.provideObjClass("Author", {
  attributes: {
    description: "string",
    image: ["reference", { only: ["Image"] }],
    ...metadataAttributes,
    ...defaultPageAttributes,
  },
  extractTextAttributes: ["description"],
});

export default Author;
